import type { ReactElement } from "react";
import { Icon } from "@chakra-ui/react";
import type { IconProps } from "@chakra-ui/react";

const BloggerLogo = ({
  color = "#F57D00",
  ...props
}: IconProps): ReactElement => (
  <Icon viewBox="0 0 128 128" color={color} {...props}>
    <title>Blogger Logo</title>
    <path
      fill="currentColor"
      d="M64 0c35.347 0 64 28.653 64 64s-28.653 64-64 64S0 99.347 0 64 28.653 0 64 0zm25.48 56.683H86.2c-2.01 0-3.773-1.7-3.91-3.656 0-10.44-8.417-18.29-18.927-18.29H53.77c-10.503 0-19.023 8.46-19.03 18.9V74.37c0 10.44 8.527 18.893 19.03 18.893h20.483c10.51 0 19.007-8.453 19.007-18.893l.003-13.393c0-2.084-1.683-4.29-3.783-4.29v-.004zm-36.453-7.316H64c2.01 0 3.657 1.65 3.657 3.66A3.669 3.669 0 0164 56.683H53.027a3.669 3.669 0 01-3.657-3.656 3.67 3.67 0 013.657-3.66v.003-.003zm21.946 29.26H53.027a3.667 3.667 0 01-3.657-3.657 3.669 3.669 0 013.657-3.657h21.946c2.01 0 3.66 1.647 3.66 3.66 0 2.01-1.65 3.657-3.66 3.657v-.003z"
    />
  </Icon>
);

export default BloggerLogo;
